import { ShareFat } from "@phosphor-icons/react";
import { DialogProps } from "../../Dialog";
import { Modal } from "@void-orbit/ui";
import { Form } from "../../Form";
import { Select } from "../../Form/Fields/Select";
import { useTransferServiceModalController } from "../../../controllers/modals/transferServiceModalController";
import { Service } from "../../../models/Service";
import { Queue } from "../../../models/Queue";
import { Button, Variant } from "../../Buttons";

export interface TransferServiceModalProps extends Omit<DialogProps, "children">{
  service: Service;
  onTransfer: ( queueId?: string, comment?: string ) => Promise<boolean | void> | boolean | void;
  title?: string;
  submitText?: string;
  showComment?: boolean;
};

export const TransferServiceModal = ({
  open,
  service,
  onTransfer,
  title = "Transferir Atendimento",
  submitText = "Transferir",
  showComment = true,
  onClose = () => {},
}: TransferServiceModalProps ) => {
  const {
    form: {
      watch,
      setValue,
      formState: {
        errors,
        isValid,
      }
    },
    handleSubmit,
    queues,
  } = useTransferServiceModalController( service, open, onClose, onTransfer );

  return (
    <Modal
      open={ open }
      onClose={ onClose }
      title={ title }
      closeLabel="Fechar transferência de atendimento"
      icon={
        <ShareFat
          weight="duotone"
          size={ 32 }
        />
      }
    >
      <Form
        onSubmit={ handleSubmit }
      >
        <div className="inputs-view">
          <Select<Queue>
            keyProperty="id"
            name="queueId"
            label="Fila"
            options={ queues }
            selected={ queues.find(( queue ) => queue.id === watch("queueId")) as Queue }
            handleSelect={( queue ) => setValue("queueId", queue.id )}
            error={ errors.queueId?.message }
            RenderOption={( queue ) => <span>{ queue.name }</span>}
          />

          {
            showComment
              ? (
                  <div className="input-view">
                    <label className="input-label" htmlFor="transfer-comment">Comentário interno</label>
                    <textarea
                      id="transfer-comment"
                      rows={ 4 }
                      placeholder="Informe o motivo da transferência"
                      value={ watch("comment") ?? "" }
                      onChange={( event ) => setValue("comment", event.target.value )}
                    />
                  </div>
                )
              : <></>
          }
        </div>

        <div className="actions-view">
          <div className="actions-view-row">
            <div />

            <Button
              $color="text"
              $variant={ Variant.CONTAINED }
              type="submit"
              disabled={ !isValid }
            >
              { submitText }
            </Button>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
